

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { GalleryItem } from '../Career/types';
import DOMPurify from "dompurify";

// components
import { Post2 } from 'components/blog';
import ContactForm from './ContactPost';
import { Helmet } from 'react-helmet-async';

type PostContentProps = {
    gallery: GalleryItem[];
    post: Post2 | null;
};

const PostContent = ({ gallery, post }: PostContentProps) => {


    const splitDescription = (htmlContent: string) => {
        if (!htmlContent) return { firstPart: '', secondPart: '' };

        const paragraphs = htmlContent.split('</p>');

        const splitIndex = Math.min(4, paragraphs.length - 1);
        const firstPart = paragraphs.slice(0, splitIndex).join('</p>') + '</p>';
        const secondPart = paragraphs.slice(splitIndex).join('</p>');

        return { firstPart, secondPart };
    };

    const { firstPart, secondPart } = splitDescription(post?.longDescription || '');


    const sanitizeAndFixHeadings = (html: string) => {
        let clean = DOMPurify.sanitize(html);
        clean = clean.replace(/<h1>/g, "<h2>").replace(/<\/h1>/g, "</h2>");
        return clean;
    };

    const sanitizedFirstPart = sanitizeAndFixHeadings(firstPart);
    const sanitizedSecondPart = sanitizeAndFixHeadings(secondPart);


    // const sanitizedFirstPart = DOMPurify.sanitize(firstPart);
    // const sanitizedSecondPart = DOMPurify.sanitize(secondPart);

    if (!post) {
        return (
            <Container className="text-center py-5">
                <Spinner animation="border" variant="primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Container>
        );
    }

    return (

        <>
            <Helmet>
                <title>{`${post?.title} | Sales Trackify CRM & Sales Management`}</title>
                <meta name="description" content={`${post?.shortDescription}`} />

                <meta name="keywords" content={post?.metaKeywords || `${post?.blogTags}`} />

                <meta property="og:title" content={post?.title} />
                <meta property="og:description" content={post?.shortDescription} />
                <meta property="og:image" content={post?.blogImage} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={post?.title} />
                <meta name="twitter:description" content={post?.shortDescription} />
                <meta name="twitter:image" content={post?.blogImage} />
            </Helmet>

            <section className="position-relative pb-5">
                <Container>
                    <Row className="mb-5">
                        <Col lg={7}>
                            {firstPart && (
                                <div className="mb-4">
                                    <div dangerouslySetInnerHTML={{ __html: sanitizedFirstPart }} />
                                </div>
                            )}
                        </Col>
                        <Col lg={5}>
                            <div className=" border border-primary" style={{ top: '100px' }}>
                                <ContactForm />
                            </div>
                        </Col>
                    </Row>
                    {post.blogImage && (
                        <Row className="mb-5">
                            <Col lg={12}>
                                <figure className="figure text-center mb-4">
                                    <img
                                        src={post.blogImage}
                                        alt="Blog"
                                        className="figure-img img-fluid rounded shadow"
                                        style={{
                                            maxWidth: '100%',
                                            height: 'auto',
                                            maxHeight: '400px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </figure>
                            </Col>
                        </Row>
                    )}

                    {secondPart && (
                        <Row>
                            <Col lg={12}>
                                <div className="mt-4">
                                    <div dangerouslySetInnerHTML={{ __html: sanitizedSecondPart }} />
                                </div>
                            </Col>
                        </Row>
                    )}
                </Container>
            </section>

        </>
    );
};

export default PostContent;